var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTick = function SvgAlertTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E02A2A",
    strokeWidth: 1.5,
    d: "M7.983 14.524c3.62-6.406 5.43-9.61 7.914-10.434a6.67 6.67 0 0 1 4.206 0c2.484.825 4.294 4.028 7.914 10.434 3.621 6.407 5.431 9.61 4.888 12.22a7 7 0 0 1-2.102 3.72C28.86 32.25 25.24 32.25 18 32.25s-10.862 0-12.803-1.785a7 7 0 0 1-2.102-3.721c-.543-2.61 1.267-5.813 4.888-12.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E02A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.988 24h.014"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E02A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 19.5v-6"
  })));
};
export default SvgAlertTick;